import type { TOC } from '@ember/component/template-only';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketExecutiveSpiderDashboardController from 'lumen/controllers/market/executive/spider-dashboard';
import getEnv from 'lumen/helpers/get-env';

interface MarketExecutiveSpiderDashboardSignature {
  Args: {
    controller: MarketExecutiveSpiderDashboardController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-portfolios"
    @query={{@controller.extendedQueryParams}}
    @url={{@controller.urlForEmbeddedApp}}
  />
</template> satisfies TOC<MarketExecutiveSpiderDashboardSignature>;
